/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReportVibrationDaily } from './reportVibrationDaily';
import { ReportVibrationStats } from './reportVibrationStats';
import { ReportVibrationAverageStats } from './reportVibrationAverageStats';


export interface ReportVibration { 
    average?: ReportVibrationAverageStats;
    minimum?: ReportVibrationStats;
    maximum?: ReportVibrationStats;
    latest_value?: ReportVibrationStats;
    daily_view?: Array<ReportVibrationDaily>;
}

